import { render, staticRenderFns } from "./RecoveryFailure.vue?vue&type=template&id=157a6f6d&scoped=true&"
import script from "./RecoveryFailure.vue?vue&type=script&lang=js&"
export * from "./RecoveryFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a6f6d",
  null
  
)

export default component.exports